import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography, Snackbar, Alert } from '@mui/material';
import { SessionStudioProvider, useSessionStudio } from './SessionContext';
import SessionCanvas from './SessionCanvas';
import AdminLayout from 'pages/admin/components/AdminLayout';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

// Main layout component
const SessionStudioLayout: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const { selectSession, sessionData, error, clearError } = useSessionStudio();

    useEffect(() => {
        if (id) {
            const sessionId = parseInt(id, 10);
            if (!isNaN(sessionId)) {
                selectSession(sessionId);
            }
        } else {
            selectSession(null);
        }
    }, [id, selectSession]);

    return (
        <AdminLayout>
            <Box sx={{ mb: 3 }}>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link
                        underline="hover"
                        color="inherit"
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate('/admin/sessions');
                        }}
                        sx={{ cursor: 'pointer' }}
                    >
                        All Sessions
                    </Link>
                    {sessionData && (
                        <Typography color="text.primary" fontWeight="medium">
                            {sessionData.title}
                        </Typography>
                    )}
                </Breadcrumbs>
            </Box>

            <Box sx={{
                overflow: 'auto',
                position: 'relative'
            }}>
                <SessionCanvas />
            </Box>

            <Snackbar
                open={Boolean(error)}
                autoHideDuration={6000}
                onClose={clearError}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={clearError} severity="error" sx={{ width: '100%' }}>
                    {error}
                </Alert>
            </Snackbar>
        </AdminLayout>
    );
};

// Wrapper to provide context
const SessionStudioPage: React.FC = () => {
    return (
        <SessionStudioProvider>
            <SessionStudioLayout />
        </SessionStudioProvider>
    );
};

export default SessionStudioPage;
